module.exports = __webpack_public_path__ + "static/media/insurance.a486cca5.svg";